<!--
 * @Author: quwandong
 * @Date: 2022-12-29 11:28:12
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-10-30 09:39:06
 * @FilePath: /adm.xiangli360.com/src/components/QueryMap/index.vue
 * @Description: 
-->
<template>
  <el-dialog
    title="地图位置标注"
    :visible.sync="dialogVisible"
    width="1080px"
    class="dialog-bg"
    :close-on-click-modal="false"
    @close="onDialogClose"
  >
    <el-popover
      placement="bottom"
      title=""
      :width="360"
      trigger="manual"
      v-model="searchResultShow"
    >
      <el-input
        slot="reference"
        @input="searchKeyWord"
        class="search-input"
        v-model="keyword"
        placeholder="搜索地点请直接输入乡镇或村名称，无需拼入省市县 "
        @focus="onInputFocus"
      >
      </el-input>
      <div
        class="result-list-item"
        v-for="item of suggestions"
        :key="item.hotPointID"
        @click="handleSelectSearch(item)"
        :title="`${item.name}-${item.address}`"
      >
        <span class="name">{{ item.name }}</span>
        <span class="address">{{ item.address }}</span>
      </div>
    </el-popover>
    <div
      id="query-map"
      @click="onClickQueryMap"
      v-loading="addMakerLoading"
    ></div>
  </el-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "QueryMap",
  data() {
    return {
      dialogVisible: false,
      keyword: "",
      suggestions: [],
      searchResultShow: false,
      addMakerLoading: false,
    };
  },
  props: {
    // 确认选择地址
    onConfirmSelectAddress: Function,
  },
  watch: {
    suggestions() {
      this.setSearchResultShowOrHide();
    },
  },
  destroyed() {
    this.map && this.map.removeEventListener("click", this.mapClickAddMaker);
  },
  methods: {
    /**
     * @description: 通过id地址获取经纬度
     * @Author: quwandong
     * @Date: 2022-12-29 19:19:58
     */
    async getLocationByIp() {
      try {
        const res = await this.$http.common.getLocationByIp({});
        const { lng, lat } = res.data.location;
        if (lng && lat) {
          this.map.centerAndZoom(new window.T.LngLat(lng, lat), 12);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 获取中心点
     * @param {*} keyWord - 所选地区
     * @Author: quwandong
     * @Date: 2022-12-29 17:35:37
     */
    async getLocationCenter(keyWord) {
      try {
        const params = {
          ds: JSON.stringify({ keyWord }),
          tk: "de76277643ead14d15ecb9dc1e9f713e",
        };
        const res = await axios.get(`https://api.tianditu.gov.cn/geocoder`, {
          params,
        });
        if (res.data.location) {
          const { lat, lon } = res.data.location;
          this.map.centerAndZoom(new window.T.LngLat(lon, lat), 12);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 初始化地图
     * @Author: quwandong
     * @Date: 2022-12-29 13:39:31
     */
    mapInit() {
      console.log(window.T);
      const TMap = window.T;
      if (this.map) return;
      this.map = new TMap.Map("query-map");
      this.map.centerAndZoom(new TMap.LngLat(116.40969, 39.89945), 12);
      this.localsearch = new TMap.LocalSearch(this.map, {
        pageCapacity: 10, //每页显示的数量
        onSearchComplete: (result) => {
          this.suggestions = result.getSuggests();
        }, //接收数据的回调函数
      });
      this.map.addEventListener("click", this.mapClickAddMaker);
    },
    /**
     * @description: 点击地图添加maker
     * @param {*} e
     * @Author: quwandong
     * @Date: 2022-12-29 18:22:59
     */
    async mapClickAddMaker(e) {
      console.log(e);
      const { lnglat } = e;
      const geocoder = new window.T.Geocoder();
      this.addMakerLoading = true;
      geocoder.getLocation(lnglat, (result) => {
        if (result.getStatus() == 0) {
          const address = result.getAddress();
          this.createMakerWithInfoWindow({
            lonlat: e.lnglat,
            address,
          });
          // 创建marker
          // this.createMakerWithInfoWindow({
          //   address,
          //   name,
          //   lonlat,
          // });
        }
        this.addMakerLoading = false;
      });
    },
    /**
     * @description: 设置联想地址结果的展示和隐藏
     * @Author: quwandong
     * @Date: 2022-12-29 17:19:02
     */
    setSearchResultShowOrHide() {
      this.searchResultShow = this.suggestions.length > 0;
    },
    /**
     * @description: 打开弹窗
     * @param {*} checkedRegionStr
     * @Author: quwandong
     * @Date: 2022-12-29 17:43:27
     */
    async openDialog(checkedRegionStr) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.mapInit();
        checkedRegionStr && this.getLocationCenter(checkedRegionStr);
        !checkedRegionStr && this.getLocationByIp();
      });
    },
    /**
     * @description: 弹窗关闭清空搜索框
     * @Author: quwandong
     * @Date: 2022-12-30 11:09:05
     */
    onDialogClose() {
      this.searchResultShow = false;
      this.keyword = "";
    },
    /**
     * @description: 联想地址
     * @Author: quwandong
     * @Date: 2022-12-29 13:47:48
     */
    searchKeyWord() {
      if (this.keyword) {
        this.localsearch.search(this.keyword, 4);
      }
    },
    /**
     * @description: 选择联想地址
     * @param {*} selectItem
     * @Author: quwandong
     * @Date: 2022-12-30 14:16:49
     */
    handleSelectSearch({ address, name }) {
      const geocoder = new window.T.Geocoder();
      geocoder.getPoint(address + name, (result) => {
        if (result.getStatus() == 0) {
          const lonlat = result.getLocationPoint();
          // 创建marker
          this.createMakerWithInfoWindow({
            address,
            name,
            lonlat,
          });
        }
      });
    },
    /**
     * @description: 创建marker和infoWindow
     * @Author: quwandong
     * @Date: 2022-12-29 15:29:45
     */
    createMakerWithInfoWindow(addressDetail) {
      const { lonlat, address, name } = addressDetail;
      const T = window.T;
      const icon = new T.Icon({
        iconUrl: require("@/assets/biaozhu_dingwei.png"),
        iconSize: new T.Point(22, 32),
        iconAnchor: new T.Point(10, 25),
      });
      const { lng, lat } = lonlat;
      const marker = new T.Marker(new T.LngLat(lng, lat), { icon });
      this.map.addOverLay(marker);
      const infoWindow = new T.InfoWindow();
      const addressInfo = name ? `${address}${name}` : address;
      infoWindow.setContent(`
        <div class="address-title" style="font-size: 16px;color: #00082C;">
          ${addressInfo}
        </div>
        <div class="position-num" style="font-size: 14px;color: #999;">经度：${lng} 纬度：${lat}</div>
        <div class="confirm-place">
          <div class="confirm-place-btn">确认位置</div>
        </div>
      `);
      marker.addEventListener("click", () => {
        marker.openInfoWindow(infoWindow);
      });

      this.$nextTick(() => {
        const infoPaneDom = document.querySelector(
          ".tdt-pane.tdt-infoWindow-pane"
        );
        // 点击确定
        infoPaneDom.addEventListener("click", (e) => {
          this.onConfirmSelectPlace(e, addressDetail);
        });
      });

      marker.openInfoWindow(infoWindow);
      this.map.centerAndZoom(new T.LngLat(lng, lat), 12);

      if (name) {
        this.keyword = name;
      }

      this.searchResultShow = false;
    },
    /**
     * @description: 点击
     * @param {*} e
     * @param {*} addressDetail
     * @Author: quwandong
     * @Date: 2022-12-29 17:16:43
     */
    onConfirmSelectPlace(e, addressDetail) {
      if (e.target.className !== "confirm-place-btn") return;

      this.$emit("onConfirmSelectAddress", addressDetail);
      this.dialogVisible = false;
    },
    /**
     * @description: 输入框聚焦
     * @Author: quwandong
     * @Date: 2022-12-29 17:18:32
     */
    onInputFocus() {
      this.searchKeyWord();
      this.searchResultShow = true;
    },
    /**
     * @description:点击输入款其他地方
     * @Author: quwandong
     * @Date: 2022-12-29 17:18:42
     */
    onClickQueryMap() {
      this.searchResultShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-dialog__body {
    position: relative;
    .search-input {
      width: 420px;
      position: absolute;
      z-index: 100;
    }
    #query-map {
      width: 100%;
      height: 650px;
      position: relative;
      z-index: 10;
    }
  }
}
</style>

<style lang="scss">
.el-popover.el-popper {
  padding: 0 !important;
  .result-list-item {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    padding: 0 12px;
    box-sizing: border-box;

    &:hover {
      background: #eeeeee;
    }

    .name {
      color: #333333;
      margin-right: 16px;
    }

    .address {
      color: #999999;
    }
  }
}

.tdt-infowindow-content-wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px 0px rgba(191, 194, 205, 0.3);
  border-radius: 4px;
  > div {
    line-height: 1.8;
  }

  .confirm-place {
    > div {
      margin: 10px auto 0;
      text-align: center;
      width: 84px;
      height: 30px;
      line-height: 30px;
      background: #018388;
      border-radius: 4px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
